import { useEffect, useState } from 'react'

/**
 * Ticking clock for "now"-relative formatting. Re-renders every `intervalMs`
 * (default 60s) so durations against in-flight workflows stay fresh without
 * recomputing on every render.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
